import {
  BULK_UPLOAD_TYPE_USER_ROLE_ASSIGNMENT,
  getApiUserManagementV1BulkUploadsErrors,
  getApiUserManagementV1BulkUploadsExportUserRoleAssignment,
  getApiUserManagementV1BulkUploadsTemplate,
  postApiUserManagementV1BulkUploadsCommit,
  postApiUserManagementV1BulkUploadsPreview,
  type BulkUploadCommitBody,
  type BulkUploadCommitWireDto,
  type BulkUploadExportFormat,
  type BulkUploadMode,
  type BulkUploadPreviewWireDto
} from '@/libs/api-user-mgt/umOpenApiGaps/bulkUploadNotInOpenApiClient';

function parseContentDispositionFilename(header: string | undefined, fallback: string): string {
  if (header == null || header.trim() === '') return fallback;
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(header);
  if (match?.[1]) {
    try {
      return decodeURIComponent(match[1].replace(/"/g, '').trim());
    } catch {
      return fallback;
    }
  }
  return fallback;
}

async function blobDownload(
  response: { data: Blob; headers?: Record<string, unknown> },
  fallbackFilename: string
): Promise<{ blob: Blob; filename: string }> {
  const disposition =
    typeof response.headers === 'object' && response.headers != null && 'content-disposition' in response.headers
      ? String(response.headers['content-disposition'])
      : undefined;
  return {
    blob: response.data,
    filename: parseContentDispositionFilename(disposition, fallbackFilename)
  };
}

export const userManagementBulkUploadSegment = {
  exportUserRoleAssignment: async (format: BulkUploadExportFormat = 'csv'): Promise<{ blob: Blob; filename: string }> => {
    const response = await getApiUserManagementV1BulkUploadsExportUserRoleAssignment(format);
    const extension = format === 'xlsx' ? 'xlsx' : 'csv';
    return blobDownload(response, `user-role-assignment-export.${extension}`);
  },

  downloadBulkUploadTemplate: async (
    uploadType: string = BULK_UPLOAD_TYPE_USER_ROLE_ASSIGNMENT,
    format: BulkUploadExportFormat = 'csv'
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await getApiUserManagementV1BulkUploadsTemplate(uploadType, format);
    const extension = format === 'xlsx' ? 'xlsx' : 'csv';
    return blobDownload(response, `${uploadType}-template.${extension}`);
  },

  previewBulkUpload: async (file: File, uploadType: string, mode: BulkUploadMode): Promise<BulkUploadPreviewWireDto> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('uploadType', uploadType);
    formData.append('mode', mode);
    const response = await postApiUserManagementV1BulkUploadsPreview(formData);
    return response.data;
  },

  commitBulkUpload: async (body: BulkUploadCommitBody): Promise<BulkUploadCommitWireDto> => {
    const response = await postApiUserManagementV1BulkUploadsCommit(body);
    return response.data;
  },

  downloadBulkUploadErrors: async (previewId: string): Promise<{ blob: Blob; filename: string }> => {
    const response = await getApiUserManagementV1BulkUploadsErrors(previewId);
    return blobDownload(response, `bulk-upload-errors-${previewId}.csv`);
  }
};
